import { RequiredMediaSource, usePublicSession } from '@app/api';
import DetectRTC from 'detectrtc';
import { useEffect, useMemo, useState } from 'react';
import { useBrowserDeviceCategory } from '../../Home/components/useBrowserDeviceCategory';

export const useDevicesInfo = () => {
  const [devicesInfo, setDevicesInfo] = useState<any | null>(null);
  const [ready, setReady] = useState<boolean>(false);
  useEffect(() => {
    setReady(false);
    DetectRTC.load(() => {
      setDevicesInfo(DetectRTC);
      setReady(true);
    });
  }, [setDevicesInfo, setReady]);

  return { devicesInfo, ready };
};

export const useCheckDevicesInfo = (sessionId?: string) => {
  const { data: session } = usePublicSession(sessionId);
  const { devicesInfo, ready } = useDevicesInfo();

  const deviceCategory = useBrowserDeviceCategory();

  return useMemo(() => {
    const isWebcamRequired = session?.requiredMediaSource?.includes(
      RequiredMediaSource.VIDEO,
    );
    const isMicrophoneRequired = session?.requiredMediaSource?.includes(
      RequiredMediaSource.AUDIO,
    );

    return {
      devicesInfo,
      ready,
      isValidDevice:
        session &&
        (!session.allowedDevicesCategories ||
          session.allowedDevicesCategories.includes(deviceCategory)),
      deviceCategory,

      isValidWebcam: devicesInfo?.hasWebcam,
      isWebcamRequired,

      isValidMicrophone: devicesInfo?.hasMicrophone,
      isMicrophoneRequired,
    };
  }, [devicesInfo, ready, session, deviceCategory]);
};
